import React from "react";
import { Shuffle } from "lucide-react";
import { COUNTRIES, COUNTRY_TO_ISO2 } from "./constants/countries";

// Single-country picker for reverse lookups: "who can this country let in?"
// No add/remove here — reverse mode only ever looks at one destination.
const ReverseCountryPicker = ({ selectedCountry, onChange }) => {
  const iso2 = COUNTRY_TO_ISO2[selectedCountry];

  const randomize = () => {
    const randomIndex = Math.floor(Math.random() * COUNTRIES.length);
    onChange(COUNTRIES[randomIndex]);
  };

  return (
    <section className="my-7" aria-label="Country to check">
      <span className="block font-mono text-[0.72rem] font-medium tracking-[0.18em] uppercase text-ink-muted mb-2.5">
        Which country's border are we checking?
      </span>
      <div className="flex flex-wrap items-center gap-2.5">
        <div className="inline-flex items-center bg-white border border-hairline border-l-4 border-l-navy rounded-md">
          {iso2 && (
            <span
              className={`fi fi-${iso2.toLowerCase()} ml-2.5 rounded-[2px]`}
            />
          )}
          <select
            value={selectedCountry}
            onChange={(e) => onChange(e.target.value)}
            aria-label="Country to check"
            className="font-mono text-sm text-ink bg-transparent py-2 pl-2 pr-1 max-w-[13rem] cursor-pointer"
          >
            {COUNTRIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
          <button
            className="p-2 border-l border-hairline rounded-r-md text-ink-muted hover:text-navy hover:bg-navy-soft transition-colors"
            onClick={randomize}
            aria-label="Shuffle country"
            type="button"
          >
            <Shuffle size={15} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ReverseCountryPicker;
